export const formatPhone = (phone: string) => {
  const maskDigits = phone.replace(/^(\+\d\d)|(\d\d\d\d)$/g, '')

  const count = maskDigits.length

  return phone.replace(maskDigits, '*'.repeat(count))
}
